import lodashMerge from 'lodash/merge';
import queryString from 'query-string';

import {assertDependencies} from '../lib/util';

const PROVIDER_NAME = 'query_string';

const MANIFEST = require('./manifest');

const DEFAULT_OPTIONS = {
	// Key under which user id will be provided within query string
	key: 'user_id',
};

function QueryUserProvider(options = DEFAULT_OPTIONS, deps = MANIFEST.dependencies) {
	const thisQueryUserProvider = this;

	options = lodashMerge({}, DEFAULT_OPTIONS, options);
	assertDependencies(MANIFEST.name, MANIFEST.dependencies, deps);

	const log = deps.logger.child(MANIFEST.name); // eslint-disable-line no-unused-vars

	let _userId = fetchUserId();

	Object.assign(thisQueryUserProvider, /** @lends QueryUserProvider.prototype */ {
		getUserId,
		getProviderName: () => PROVIDER_NAME
	});

	function getUserId(callback) {
		if (callback) {
			callback(null, _userId);
		}
		return _userId;
	}

	function fetchUserId() {
		if (!options.key) {
			// Treat the entire query as user_id
			return deps.location.search;
		}

		const qs = queryString.parse(deps.location.search);
		return qs[options.key] || null;
	}
}

// *********************************************************************************************************************

export default QueryUserProvider;
